import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // staging and prod share one Sentry project (DSN) — without this tag every
  // event defaults to Sentry's implicit "production" bucket, so staging
  // errors would be indistinguishable from real prod errors. VITE_APP_ENV is
  // already set per-box ("staging"/"production") for this exact purpose.
  environment: import.meta.env.VITE_APP_ENV,
  // DEV-281: was `true`. That attaches the user's IP + full request headers
  // (incl. the session Cookie) to every captured event — a live session
  // cookie ending up in a third-party (Sentry) error report is a real PII
  // leak. `false` is Sentry's own default; there's no product need here to
  // override it.
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: false,
  integrations: [
    // DEV-281: these are already replayIntegration()'s defaults (masked by
    // default) — spelled out explicitly so the control survives a future
    // Sentry SDK version silently changing its defaults, and so it's
    // visible in code for HITRUST review instead of implicit.
    Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
  ],
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
